module.exports = {"pathContext":{"slug":"/it/master/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-master.json
// module id = 1590
// module chunks = 142504720629826